const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const fetchLineOfBusiness = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/references/line_of_businesses/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            //credentials: 'include', // Include cookies in the request
        });
        //console.log('=====response======', response)
        const responseBody = await response.json();
        if (response.status < 300) {

            return responseBody;
          }
          else
          {
                //console.log('body======', responseBody.error, `Status ${response.status}`);
                //throw new Error(response.statusText || `Error: Status ${response.status}`);
                throw new Error(`${responseBody.error} status ${response.status}`);
          }
        
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(`Failed to get reference-line of business: ${error.message}`);
        } else {
            throw new Error('Failed to get reference-line of business: An unknown error occurred.');
        }
    }
  };
  

  export const fetchProjectType = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/references/project_types/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            //credentials: 'include', // Include cookies in the request
        });
        //console.log('=====response======', response)
        const responseBody = await response.json();
        if (response.status < 300) {

            return responseBody;
          }
          else
          {
                //console.log('body======', responseBody.error, `Status ${response.status}`);
                //throw new Error(response.statusText || `Error: Status ${response.status}`);
                throw new Error(`${responseBody.error} status ${response.status}`);
          }
        
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(`Failed to get reference-project type: ${error.message}`);
        } else {
            throw new Error('Failed to get reference-project type: An unknown error occurred.');
        }
    }
  };
  

  export const fetchEmployeeType = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/references/employee_types/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            //credentials: 'include', // Include cookies in the request
        });
        //console.log('=====response======', response)
        const responseBody = await response.json();
        if (response.status < 300) {

            return responseBody;
          }
          else
          {
                //console.log('body======', responseBody.error, `Status ${response.status}`);
                //throw new Error(response.statusText || `Error: Status ${response.status}`);
                throw new Error(`${responseBody.error} status ${response.status}`);
          }
        
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(`Failed to get reference-employee type: ${error.message}`);
        } else {
            throw new Error('Failed to get reference-employee type: An unknown error occurred.');
        }
    }
  };
  
  export const fetchEmployeeTitle = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/references/employee_titles/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            //credentials: 'include', // Include cookies in the request
        });
        //console.log('=====response======', response)
        const responseBody = await response.json();
        if (response.status < 300) {

            return responseBody;
          }
          else
          {
                //console.log('body======', responseBody.error, `Status ${response.status}`);
                //throw new Error(response.statusText || `Error: Status ${response.status}`);
                throw new Error(`${responseBody.error} status ${response.status}`);
          }
        
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(`Failed to get reference-employe title: ${error.message}`);
        } else {
            throw new Error('Failed to get reference-employee title: An unknown error occurred.');
        }
    }
  };
  